@if (isCUSTOM_HOMEPAGE) {
  <div id="landing-page" class="un-landing-page-scroll-container">
    <div [ngClass]="{'with-homepage': homePage}" class="landing-page-container">
      <div class="header-row">
        <h1 class="header">District Home</h1>
        @if (homePage && isDestinyAdmin()) {
          <button class="edit-page-btn" (click)="goToSettings()">Edit Page</button>
        }
      </div>
      <div class="content-row">
        <div [ngClass]="{'minimized': homePage}" class="new-landing-page">
          <h2 class="directory-header">Sites Directory</h2>
          <div class="button-row">
            <div id="search-area" class="search-area">
              <input
                #schoolFilterInput
                matInput
                id="school-filter-input"
                class="searchbox"
                type="text"
                placeholder="Filter sites"
                [(ngModel)]="filterText"
                (input)="filterSchools($event)"
                (keydown)="handleInputKeyEvent($event)"
                />
                @if (!filterText || filterText.length === 0) {
                  <span id="search-icon" class="simple-search__icon">
                    <fa-icon class="search-icons" [icon]="['far', 'magnifying-glass']"></fa-icon>
                  </span>
                }
                @if (filterText && filterText.length > 0) {
                  <button title="Clear search term" id="clear-search-icon-btn" class="simple-search__cancel" (click)="resetSearchFilter(); focus();" type="button">
                    <fa-icon class="search-icons" [icon]="['far', 'circle-x']"></fa-icon>
                  </button>
                }
              </div>
              @if (!homePage && isDestinyAdmin()) {
                <button class="edit-page-btn" (click)="goToSettings()">Edit Page</button>
              }
            </div>
            @if ((filteredSites$ | async)?.length > 0) {
              <div [ngClass]="{'accordion-list': homePage}" class="site-list">
                @for (option of getSiteTypes(); track option; let siteTypeIndex = $index) {
                  <mat-accordion class="card">
                    <mat-expansion-panel class="expansion-panel" [expanded]="(homePage && !isCollapsed(option)) || !homePage" (keydown.enter)="addCollapsed(option)" (click)="addCollapsed(option)" [hideToggle]="!homePage" [disabled]="!homePage">
                      <mat-expansion-panel-header class="expansion-panel-header">
                        <h3 class="sitetype">{{option}} ({{getSitesByTypes(option).length}})</h3>
                      </mat-expansion-panel-header>
                      <div class="sites">
                        @for (st of getSitesByTypes(option); track st; let siteIndex = $index) {
                          <div class="site">
                            <button id="siteType-{{siteTypeIndex}}-site-{{siteIndex}}" class="site-name" [title]="getSiteNameWithId(st)" (click)="switchSiteTo(st)">{{st.siteName}}</button>
                            <button id="bookmarks-{{siteTypeIndex}}-site-{{siteIndex}}" (click)="$event.stopPropagation()" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Bookmark menu" class="copy-btn">
                              <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu id="bookmarkmenu" #menu="matMenu" class="district-mat-menu">
                              <div class="menu-content">
                                <button mat-menu-item id="copy-destiny-link" (click)="copyLink(st, Application.DESTINY)" class="copy-link-btn">
                                  Copy Destiny Back Office Link
                                </button>
                                <hr />
                                <button mat-menu-item id="copy-dd-link" (click)="copyLink(st, Application.DD)" class="copy-link-btn">
                                  Copy Destiny Discover Link
                                </button>
                              </div>
                            </mat-menu>
                          </div>
                        }
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                }
              </div>
            }
          </div>
          @if (homePage) {
            <div class="home-page">
              <quill-view format="json" [content]="homePage"></quill-view>
            </div>
          }
        </div>
      </div>
    </div>
  } @else {
    <div id="landing-page" class="landing-page">
      <div class="site-section" (keydown.tab)="$event.stopPropagation()" (keydown.shift.tab)="$event.stopPropagation()">
        @if ((enrolledSites$ | async)?.length > 0) {
          <div id="site-header" class="site-header" (click)="$event.stopPropagation()">
            <div id="search-area" class="search-area">
              <input
                #schoolFilterInput
                matInput
                id="school-filter-input"
                class="searchbox"
                type="text"
                placeholder="Search Sites"
                [value]="filterText"
                (input)="filterSchools($event)"
                (keydown)="handleInputKeyEvent($event)"
                />
                @if (!filterText || filterText.length === 0) {
                  <span id="search-icon" class="simple-search__icon">
                    <mat-icon class="search-icons" [svgIcon]="icons.SEARCH"></mat-icon>
                  </span>
                }
                @if (filterText?.length > 0) {
                  <button title="Clear search term" id="clear-search-icon-btn"
                    class="simple-search__cancel" (click)="resetSearchFilter(); focus();" type="button">
                    <mat-icon class="search-icons" [svgIcon]="icons.CLEAR"></mat-icon>
                  </button>
                }
              </div>
            </div>
          }
          @if ((filteredSites$ | async)?.length > 0) {
            <div class="site-cards">
              @for (option of getSiteTypes(); track option; let siteTypeIndex = $index) {
                <div class="card-wrapper">
                  <mat-card class="card">
                    <mat-card-header class="header">
                      <span class="sitetype">{{option}} ({{getSitesByTypes(option).length}})</span>
                    </mat-card-header>
                    <mat-card-content>
                      @for (st of getSitesByTypes(option); track st; let siteIndex = $index) {
                        <div class="sites">
                          <button id="siteType-{{siteTypeIndex}}-site-{{siteIndex}}" class="sitename" [title]="getSiteNameWithId(st)" (click)="switchSiteTo(st)"
                          (keydown.enter)="switchSiteTo(st)">{{st.siteName}}</button>
                          <button id="bookmarks-{{siteTypeIndex}}-site-{{siteIndex}}" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Bookmark menu" class="copy-btn">
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <mat-menu id="bookmarkmenu" #menu="matMenu" class="district-mat-menu">
                            <div class="menu-content">
                              <button mat-menu-item id="copy-destiny-link" (click)="copyLink(st, Application.DESTINY)" class="copy-link-btn">
                                Copy Destiny Back Office Link
                              </button>
                              <hr />
                              <button mat-menu-item id="copy-dd-link" (click)="copyLink(st, Application.DD)" class="copy-link-btn">
                                Copy Destiny Discover Link
                              </button>
                            </div>
                          </mat-menu>
                        </div>
                      }
                    </mat-card-content>
                  </mat-card>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
